import React from "react";
import { Icon } from "components/SvgIcons";
import { Container, IconWrap, Content, Title, Text, ImagesContainer, AppStoreImage, QRcontainer } from "./styled";
import Button from "shared/Button";
import Modal from "shared/Modal";

const BuyInAppModal = (props) => {
  const openAppStoreLink = () => {
    window.open("https://apps.apple.com/si/app/foody/id6443809822", "_blank");
  };

  return props.isVisible ? (
    <Modal width={640} type="buyInApp">
      <Container>
        <IconWrap onClick={props.onClose}>
          <Icon icon="close_2" />
        </IconWrap>
        <Content>
          <Title>Get the recipe in the app</Title>
          <Text>
            Download the Foody+ app to get access to premium recipes, create weekly plans, create a grocery list, and so
            much more. Download the app free in the App Store.
          </Text>
          <ImagesContainer>
            <AppStoreImage src="/images/appleStore.png" alt="App Store" onClick={openAppStoreLink} />
            <QRcontainer>
              <img src="/images/qrAppCode.png" alt="qr code" />
              <p>Scan the code to download the app</p>
            </QRcontainer>
          </ImagesContainer>
          <Button
            stylType="primary"
            text={"Continue to Purchase on the Web"}
            id="continue"
            color={"#F7DECE"}
            onClick={props.confirm}
            textColor={"#FF6500"}
          />
        </Content>
      </Container>
    </Modal>
  ) : null;
};

export default BuyInAppModal;
